.panel-container {
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.3rem;
}

.header-text {
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: #afb4c0;
}

.amount-space-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.amount {
  font-style: normal;
  font-weight: 400;
  line-height: 2.4rem;
  color: #ffffff;

  &[data-disable='true'] {
    color: #626878;
  }
}

.footer {
  margin-top: 4rem;
  color: var(--color-grayscale-manatee);
  font-size: 1.4rem;

  a {
    color: var(--color-primary-crayola);
  }
}
